const mgmresorts = require('./mgmresorts');
const cosmopolitan = require('./cosmopolitan');
module.exports = {
  mgmresorts,
  cosmopolitan
};
